import React from "react";
import { Button, Col, FormLabel, Row, Table } from "react-bootstrap";
import { AppContext } from "../AppContext.js";
import { PageListBean } from "../ds/client_ds.js";
import {
  InventoryAdjustmentReasonBean,
  InventoryAdjustmentReasonSearchCriteria,
  RestInventoryAdjustmentReasonListRequest,
  RestReadRequest,
} from "../ds/ds.js";
import { DeleteIcon, DropDwnDown, DropDwnUp } from "../gui_components/Icons.js";
import {
  AlertToolBox,
  InputCheckbox,
  InputTextbox,
  ShowError,
} from "../gui_components/UIComponents.js";
import { isEmptyArray, isEmptyString } from "../gui_components/Util.js";
import {
  BaseInquiryPageListToolBar,
  BaseInquiryToolBar,
  BaseToolBar,
} from "../modules/BaseModule.js";
import { SecurityAccessManager } from "../security/SecurityAccessManager.js";
import { MasterService } from "../services/MasterService.js";
class InventoryAdjustmentReasonListForm extends React.Component {
  constructor(props) {
    super(props);
    this.listFormCodeRef = React.createRef();
    this.state = {};
  }

  componentDidMount() {}

  componentDidUpdate() {
    this.setInputFocus();

    //
  }
  setInputFocus() {
    if (this.listFormCodeRef.current != null) {
      this.listFormCodeRef.current.focus();
    }
  }
  enterKeyEventHandler = (e) => {
    this.props.enterKeyEventHandler(e);
  };
  editInventoryAdjustmentReason = (e, val, rowdata) => {
    if (e.detail === 1) this.props.editInventoryAdjustmentReason(val, rowdata);
  };
  deleteInvAdjustment = (e, rowData) => {
    if (e.detail === 1) this.props.deleteInvAdjustment(rowData);
  };
  onChange = (e) => {
    this.props.onChange(e);
  };
  handleSortingChange = (e, accessor) => {
    if (e.detail === 1) this.props.handleSortingChange(accessor);
  };
  opentypeforms = (e) => {
    if (e.detail === 1) this.props.opentypeforms();
  };
  render() {
    let inventoryAdjustmentReason_list =
      this.props.inventoryAdjustmentReason_list;
    return (
      <div>
        <div>
          <Row>
            <Col sm="1">
              <FormLabel id="searchBarLabel">
                Inventory Adjustment Reason
              </FormLabel>
            </Col>
            <Col sm="2">
              <InputTextbox
                type="text"
                name="code"
                onChange={this.props.onChange}
                value={this.props.inventoryAdjustmentReasonData.code}
                style={{ "text-transform": "uppercase" }}
                enterKeyEventHandler={this.props.enterKeyEventHandler}
                ref={this.listFormCodeRef}
                isMandatory={true}
              ></InputTextbox>
            </Col>

            <Col sm="1">
              <Button
                id="fabric_Add_Button"
                className="text-center"
                onClick={(e) => this.opentypeforms(e)}
              >
                Go
              </Button>
            </Col>
          </Row>
        </div>
        <div className="div_default">
          <Table id="fabrics_tables_default">
            <thead>
              <tr>
                <th onClick={(e) => this.handleSortingChange(e, "code")}>
                  Code{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "code" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "description")}>
                  Name{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "description" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "companyCode")}>
                  CompanyCode{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "companyCode" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                <th onClick={(e) => this.handleSortingChange(e, "isActive")}>
                  Active{" "}
                  {this.props.order === "desc" &&
                  this.props.sortField === "isActive" ? (
                    <span className="drp-dwn-cntr">
                      <DropDwnUp />
                    </span>
                  ) : (
                    <span className="drp-dwn-cntr">
                      <DropDwnDown />
                    </span>
                  )}
                </th>
                {/* <th>Remove</th> */}
              </tr>
            </thead>
            {inventoryAdjustmentReason_list != null ? (
              <tbody>
                {inventoryAdjustmentReason_list.map((Info, index) => (
                  <tr key={index} data-item={Info}>
                    <td>
                      <Button
                        variant="secondry"
                        className="td_attribute_width"
                        onClick={(e) =>
                          this.editInventoryAdjustmentReason(e, Info.code)
                        }
                      >
                        {Info.code}
                      </Button>
                    </td>
                    <td> {Info.description}</td>
                    <td>{Info.companyCode}</td>
                    <td>{Info.isActive}</td>
                    {/* <td className="text-right">
                      <Button
                        variant="secondry"
                        className="hyperLinkText"
                        onClick={(e) => this.deleteInvAdjustment(e, Info.code)}
                      >
                        <DeleteIcon />
                      </Button>
                    </td> */}
                  </tr>
                ))}
              </tbody>
            ) : null}
          </Table>
          {inventoryAdjustmentReason_list.length != 0 ? null : (
            <div className="no_Data">{"NO DATA"}</div>
          )}
        </div>
      </div>
    );
  }
}

class InventoryAdjustmentReasonEntryForm extends React.Component {
  constructor(props) {
    super(props);
    this.codeRef = React.createRef();
    this.state = {
      inventoryAdjustmentReasonData: this.props.inventoryAdjustmentReasonData,
    };
  }
  componentDidMount() {
    this.setInputFocus();
  }
  componentDidUpdate() {
    //
  }
  setInputFocus() {
    if (this.codeRef.current != null) {
      this.codeRef.current.focus();
    }
  }
  onChange = (e) => {
    this.props.onChange(e);
  };
  saveInventoryAdjustmentReason = (e) => {
    this.props.saveInventoryAdjustmentReason(
      this.state.inventoryAdjustmentReasonData
    );
  };
  closeInventoryAdjustmentReasonEntryForm() {
    this.props.closeInventoryAdjustmentReasonEntryForm();
  }
  render() {
    let inventoryAdjustmentReasonData =
      this.props.inventoryAdjustmentReasonData;
    let isDisableFields = this.props.isDisableFields;
    return (
      <div>
        <Row>
          <Col sm="1">
            {" "}
            <FormLabel>Company Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="companyCode"
              type="text"
              placeholder="Enter CompanyCode"
              onChange={this.onChange}
              value={inventoryAdjustmentReasonData.companyCode}
              disabled="true"
            />{" "}
          </Col>
          <Col sm="1">
            {" "}
            <FormLabel>Code</FormLabel>{" "}
          </Col>
          <Col sm="2">
            {" "}
            <InputTextbox
              name="code"
              type="text"
              placeholder="Enter InventoryAdjustmentReasonCode"
              onChange={this.onChange}
              value={inventoryAdjustmentReasonData.code}
              style={{ "text-transform": "uppercase" }}
              disabled={isDisableFields}
              ref={this.codeRef}
              isMandatory={true}
            />{" "}
          </Col>
          <Col sm="1">
            <FormLabel>Name</FormLabel>{" "}
          </Col>
          <Col sm="2">
            <InputTextbox
              name="description"
              type="text"
              placeholder="Enter Name"
              onChange={this.onChange}
              value={inventoryAdjustmentReasonData.description}
              style={{ "text-transform": "capitalize" }}
              isMandatory={true}
            />
          </Col>
          <Col sm="1">
            <FormLabel>Active</FormLabel>
          </Col>
          <Col sm="2">
            {" "}
            <InputCheckbox
              type="checkbox"
              name="isActive"
              onChange={this.onChange}
              checked={inventoryAdjustmentReasonData.isActive}
            />
          </Col>
        </Row>
        <br />
      </div>
    );
  }
}
class InventoryAdjustmentReasonList extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {
      inventoryAdjustmentReason_list: [],
      response: {},
      pageTitle: "Inventory Adjustment Reason",
      inventoryAdjustmentReasonData: new InventoryAdjustmentReasonBean(),
      pageList: new PageListBean(),
      criteria: new InventoryAdjustmentReasonSearchCriteria(),
      companyCode: "",
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: false,
      isShowBackButton: false,
      error_list: [],
      currentPageNumber: 0,
      totalCount: 0,
      isInventoryAdjustmentReasonListFormOpen: true,
      isInventoryAdjustmentReasonEntryFormOpen: false,
      isShowNodes: false,
      selectedNode: "headerView",
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      alertMessage: [],
      alertType: "",
      isShowAlert: false,
      isShowCode: false,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isShowExitButton: true,
      isDisableFields: false,
      order: "asc",
      sortField: "",
    };
  }

  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.loadPage(1);
    this.cleardata();
  }
  moduleCaption = "Inventory Adjustment Reason";
  opentypeforms = () => {
    let inventoryAdjustmentReasonData =
      this.state.inventoryAdjustmentReasonData;
    this.editInventoryAdjustmentReason(inventoryAdjustmentReasonData.code);
  };
  enterKeyEventHandler = (e) => {
    e.preventDefault();
    setTimeout(() => {
      this.opentypeforms();
    }, 200);
  };
  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  cleardata = () => {
    let inventoryAdjustmentReasonData = new InventoryAdjustmentReasonBean();
    inventoryAdjustmentReasonData.companyCode = this.companyCode;
    this.setState({
      inventoryAdjustmentReasonData: inventoryAdjustmentReasonData,
    });
  };
  saveInventoryAdjustmentReasonResponse = (response) => {
    if (response.data.success) {
      this.handleresponse(response.data);
      this.loadPage(1);
      this.cleardata();
      this.clearError();
      this.closeInventoryAdjustmentReasonEntryForm();
      this.setState({ isShowCode: false });
    } else {
      this.handleresponse(response.data);
    }
  };
  validateInventoryAdjustmentReason = (inventoryAdjustmentReasonData) => {
    let isInventoryAdjustmentReason = false;
    let err_list = [];
    let errorMessage = "";
    if (inventoryAdjustmentReasonData == null) {
      let errMsg = "Enter All Fields ";
      errorMessage = errorMessage + errMsg;
      err_list.push(errMsg);
    } else {
      if (isEmptyString(inventoryAdjustmentReasonData.description)) {
        let errMsg = "InventoryAdjustmentReason Name is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
      if (isEmptyString(inventoryAdjustmentReasonData.code)) {
        let errMsg = "InventoryAdjustmentReason Code is Required";
        errorMessage = errorMessage + errMsg;
        err_list.push(errMsg);
      }
    }
    if (err_list.length > 0) {
      isInventoryAdjustmentReason = false;
      this.setState({
        alertMessage: err_list,
        alertType: "danger",
        isShowAlert: true,
      });
    } else {
      isInventoryAdjustmentReason = true;
      this.setState({ isShowAlert: false });
    }
    return isInventoryAdjustmentReason;
  };
  saveInventoryAdjustmentReason = (inventoryAdjustmentReasonData) => {
    let isValidLine = false;
    isValidLine = this.validateInventoryAdjustmentReason(
      inventoryAdjustmentReasonData
    );
    if (isValidLine) {
      if (inventoryAdjustmentReasonData.isFetched == true) {
        if (
          SecurityAccessManager.InventoryAdjustmentReasonMaintenanceEdit_IsAccessible()
        ) {
          MasterService.updateInventoryAdjustmentReason(
            inventoryAdjustmentReasonData,
            this.saveInventoryAdjustmentReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Edit Access Denied";
          let errList = this.state.error_list;
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      } else {
        if (
          SecurityAccessManager.InventoryAdjustmentReasonMaintenanceCreate_IsAccessible()
        ) {
          MasterService.createInventoryAdjustmentReason(
            inventoryAdjustmentReasonData,
            this.saveInventoryAdjustmentReasonResponse,
            this.errorCallBack
          );
        } else {
          let errMsg = "Create Access Denied";
          let errList = this.state.error_list;
          errList.push(errMsg);

          this.setState({
            alertMessage: errList,
            alertType: "danger",
            isShowAlert: true,
          });
        }
      }
    }
  };

  editInventoryAdjustmentReasonResponse = (response) => {
    if (response.data != null) {
      if (!isEmptyArray(response.data.inventoryAdjustmentReasonBean)) {
        let inventoryAdjustmentReasonData = new InventoryAdjustmentReasonBean();
        inventoryAdjustmentReasonData =
          response.data.inventoryAdjustmentReasonBean;
        this.setState({
          inventoryAdjustmentReasonData: inventoryAdjustmentReasonData,
        });
        this.disable();
      }
    }
    this.openInventoryAdjustmentReasonEntryForm();
  };
  editInventoryAdjustmentReason = (code) => {
    let readrestInput = new RestReadRequest();
    readrestInput.companyCode = this.companyCode;
    readrestInput.code = code;
    if (
      SecurityAccessManager.InventoryAdjustmentReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.readInventoryAdjustmentReason(
        readrestInput,
        this.editInventoryAdjustmentReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };

  onChange = (e) => {
    let temp_inventoryAdjustmentReasondata =
      this.state.inventoryAdjustmentReasonData;
    temp_inventoryAdjustmentReasondata[e.target.name] = e.target.value;
    this.setState({
      inventoryAdjustmentReasonData: temp_inventoryAdjustmentReasondata,
    });
  };
  handleresponse = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = this.state.error_list;
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        )
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }

    if (response.infos != null) {
      let infoMsg = "";
      let successList = [];
      response.infos.map(
        (info) => (
          (infoMsg = infoMsg + info.messageDescription),
          successList.push(info.messageDescription)
        )
      );
      this.setState({
        alertMessage: successList,
        alertType: "success",
        isShowAlert: true,
      });
    }
  };
  save = () => {
    let inventoryAdjustmentReasonData =
      this.state.inventoryAdjustmentReasonData;
    inventoryAdjustmentReasonData.companyCode = this.companyCode;
    inventoryAdjustmentReasonData.code =
      this.state.inventoryAdjustmentReasonData.code.toUpperCase();
    this.clearError();
    this.saveInventoryAdjustmentReason(inventoryAdjustmentReasonData);
  };
  back = () => {
    this.clearError();
    this.cleardata();
    this.hideAlertCallBack(false);
    this.closeInventoryAdjustmentReasonEntryForm();
    this.componentDidMount();
  };
  clearError = () => {
    this.setState({ error_list: [] });
  };
  openInventoryAdjustmentReasonEntryForm = () => {
    this.setState({
      isInventoryAdjustmentReasonListFormOpen: false,
      isInventoryAdjustmentReasonEntryFormOpen: true,
      isShowSaveButton: true,
      isShowClearCriteriaButton: false,
      isShowClearErrorButton: true,
      isShowBackButton: true,
      isShowNodes: false,
      isPageListToolBar: false,
      isLoadFirstButton: false,
      isLoadLastButton: false,
      isLoadPreviousButton: false,
      isLoadNextButton: false,
    });
    this.hideAlertCallBack();
  };

  closeInventoryAdjustmentReasonEntryForm = () => {
    this.clearError();
    let pageTitle = this.moduleCaption;
    this.setState({
      isInventoryAdjustmentReasonListFormOpen: true,
      isInventoryAdjustmentReasonEntryFormOpen: false,
      isShowSaveButton: false,
      isShowClearCriteriaButton: false,
      isShowBackButton: false,
      isShowClearErrorButton: false,
      pageTitle: pageTitle,
      isPageListToolBar: true,
      isLoadFirstButton: true,
      isLoadLastButton: true,
      isLoadPreviousButton: true,
      isLoadNextButton: true,
      isDisableFields: false,
    });
    this.loadPage(1);
  };

  moduleExit = () => {
    this.props.onModuleExit();
  };
  loadInventoryAdjustmentReasonResponse = (response) => {
    if (
      response.data != null &&
      response.data.inventoryAdjustmentReasonPageListBean != null
    ) {
      let inventoryAdjustmentReasonList = new Array();
      if (
        !isEmptyArray(
          response.data.inventoryAdjustmentReasonPageListBean
            .inventoryAdjustmentReasonBean
        )
      ) {
        inventoryAdjustmentReasonList =
          response.data.inventoryAdjustmentReasonPageListBean
            .inventoryAdjustmentReasonBean;
        inventoryAdjustmentReasonList.map((Info) => {
          if (Info.isActive == true) {
            Info.isActive = "True";
          } else {
            Info.isActive = "False";
          }
        });
      }
      let pageList = this.state.pageList;
      pageList.currentPage =
        response.data.inventoryAdjustmentReasonPageListBean.currentPage;
      pageList.pageSize =
        response.data.inventoryAdjustmentReasonPageListBean.pageSize;
      pageList.totalCount =
        response.data.inventoryAdjustmentReasonPageListBean.totalCount;
      this.setState({
        inventoryAdjustmentReason_list: inventoryAdjustmentReasonList,
        pageList: pageList,
      });
    }
  };
  loadFirst = () => {
    this.loadPage(1);
  };
  loadPrevious = () => {
    let currentPage = this.state.pageList.currentPage;
    let previousPage = currentPage - 1;
    this.loadPage(previousPage);
  };
  loadNext = () => {
    let currentPage = this.state.pageList.currentPage;
    let nextPage = currentPage + 1;
    this.loadPage(nextPage);
  };
  loadLast = () => {
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    let totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    this.loadPage(totalPages);
  };
  loadPage = (pageNumber) => {
    let criteria = new InventoryAdjustmentReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    let pageList = this.state.pageList;
    let pageInput = new PageListBean();
    pageInput.pageSize = 50;
    pageInput.currentPage = pageNumber;
    if (pageList != null) pageInput.totalCount = pageList.totalCount;
    this.state.pageList = pageInput;
    this.loadInventoryAdjustmentReasonPage(pageInput, criteria);
  };
  loadInventoryAdjustmentReasonPage = (pageList, searchCriteria) => {
    let criteria = new InventoryAdjustmentReasonSearchCriteria();
    criteria = searchCriteria;
    let requestInput = new RestInventoryAdjustmentReasonListRequest();
    requestInput.pageInput = pageList;
    requestInput.searchCriteria = criteria;
    this.state.pageList = pageList;
    if (
      SecurityAccessManager.InventoryAdjustmentReasonMaintenanceView_IsAccessible()
    ) {
      MasterService.getInventoryAdjustmentPageList(
        requestInput,
        this.loadInventoryAdjustmentReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "View Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteInvAdjustment = (rowData) => {
    let criteria = new InventoryAdjustmentReasonSearchCriteria();
    criteria.companyCode = this.companyCode;
    criteria.code = rowData;
    if (
      SecurityAccessManager.InventoryAdjustmentReasonMaintenanceDelete_IsAccessible()
    ) {
      MasterService.deleteInventoryAdjustmentReason(
        criteria,
        this.deleteInventoryAdjustmentReasonResponse,
        this.errorCallBack
      );
    } else {
      let errMsg = "Delete Access Denied";
      let errList = this.state.error_list;
      errList.push(errMsg);

      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
  };
  deleteInventoryAdjustmentReasonResponse = (response) => {
    this.handleresponse(response.data);
    this.loadPage(1);
  };
  hideAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowAlert: isDisplayed, error_list: [] });
  };
  errorCallBack = (error) => {
    ShowError("Error : " + error);
  };
  handleSortingChange = (accessor) => {
    let sortField = accessor;
    let order = this.state.order;
    let sortOrder = accessor === sortField && order === "asc" ? "desc" : "asc";
    this.setState({
      order: sortOrder,
      sortField: sortField,
    });
    this.handleSorting(sortField, sortOrder);
  };
  handleSorting = (sortField, sortOrder) => {
    let list = this.state.inventoryAdjustmentReason_list;
    if (sortField && !isEmptyArray(list)) {
      const sorted = [...list].sort((a, b) => {
        if (a[sortField] === null) return 1;
        if (b[sortField] === null) return -1;
        if (a[sortField] === null && b[sortField] === null) return 0;
        return (
          a[sortField].toString().localeCompare(b[sortField].toString(), "en", {
            numeric: true,
          }) * (sortOrder === "asc" ? 1 : -1)
        );
      });
      this.setState({ inventoryAdjustmentReason_list: sorted });
    }
  };
  render() {
    let pageList = this.state.pageList;
    let totalPages = 0;
    let pageSize = this.state.pageList.pageSize;
    let totalCount = this.state.pageList.totalCount;
    totalPages = totalCount / pageSize;
    totalPages += totalCount % pageSize == 0 ? 0 : 1;
    let currentPage = pageList.currentPage;
    return (
      <div>
        <AlertToolBox
          alertMsgList={this.state.alertMessage}
          alertErrorType={this.state.alertType}
          isShowAlert={this.state.isShowAlert}
          hideAlertCallBack={this.hideAlertCallBack}
        />
        {this.state.isPageListToolBar && (
          <BaseInquiryPageListToolBar
            currentPage={currentPage}
            totalPages={totalPages}
            isLoadFirstButton={this.state.isLoadFirstButton}
            isLoadLastButton={this.state.isLoadLastButton}
            isLoadPreviousButton={this.state.isLoadPreviousButton}
            isLoadNextButton={this.state.isLoadNextButton}
            loadFirst={this.loadFirst}
            loadLast={this.loadLast}
            loadNext={this.loadNext}
            loadPrevious={this.loadPrevious}
          />
        )}
        {this.state.isInventoryAdjustmentReasonListFormOpen && (
          <BaseInquiryToolBar
            onModuleExit={() => this.moduleExit()}
            pageTitle={this.state.pageTitle}
            isShowExitButton={this.state.isShowExitButton}
          />
        )}
        {!this.state.isInventoryAdjustmentReasonListFormOpen && (
          <BaseToolBar
            back={this.back}
            save={this.save}
            clearError={this.clearError}
            isShowSaveButton={this.state.isShowSaveButton}
            isShowClearCriteriaButton={this.state.isShowClearCriteriaButton}
            isShowClearErrorButton={this.state.isShowClearErrorButton}
            isShowBackButton={this.state.isShowBackButton}
            pageTitle={this.state.pageTitle}
            isShowTitle={true}
          />
        )}
        {this.state.isInventoryAdjustmentReasonListFormOpen && (
          <InventoryAdjustmentReasonListForm
            inventoryAdjustmentReason_list={
              this.state.inventoryAdjustmentReason_list
            }
            pageList={this.state.pageList}
            criteria={this.state.criteria}
            opentypeforms={this.opentypeforms}
            inventoryAdjustmentReasonData={
              this.state.inventoryAdjustmentReasonData
            }
            editInventoryAdjustmentReason={this.editInventoryAdjustmentReason}
            deleteInvAdjustment={this.deleteInvAdjustment}
            enterKeyEventHandler={this.enterKeyEventHandler}
            onChange={this.onChange}
            handleSortingChange={this.handleSortingChange}
          />
        )}
        {!this.state.isInventoryAdjustmentReasonListFormOpen && (
          <InventoryAdjustmentReasonEntryForm
            inventoryAdjustmentReasonData={
              this.state.inventoryAdjustmentReasonData
            }
            closeInventoryAdjustmentReasonEntryForm={
              this.closeInventoryAdjustmentReasonEntryForm
            }
            saveInventoryAdjustmentReason={this.saveInventoryAdjustmentReason}
            onChange={this.onChange}
            isDisableFields={this.state.isDisableFields}
          />
        )}
      </div>
    );
  }
}
function InventoryAdjustmentReasonAttributeModule(props) {
  return (
    <div id="moduleContainer" className="module_container">
      <div className="app">
        <InventoryAdjustmentReasonList {...props} name="" />
        <br />
      </div>
    </div>
  );
}
export default InventoryAdjustmentReasonAttributeModule;
